import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=4bd220f9&"
import script from "./agent.vue?vue&type=script&lang=js&"
export * from "./agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd220f9')) {
      api.createRecord('4bd220f9', component.options)
    } else {
      api.reload('4bd220f9', component.options)
    }
    module.hot.accept("./agent.vue?vue&type=template&id=4bd220f9&", function () {
      api.rerender('4bd220f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manager/agent.vue"
export default component.exports